import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-in-out-actions',
  templateUrl: './in-out-actions.component.html',
  styleUrls: ['./in-out-actions.component.css']
})
export class InOutActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
